import productImg01 from "../images/double-sofa-01.png";
import productImg02 from "../images/double-sofa-02.png";
import productImg03 from "../images/double-sofa-03.png";
import productImg4 from "../images/double-sofa-04.png";

import productImg04 from "../images/single-sofa-00.png";
import productImg05 from "../images/single-sofa-01.png";
import productImg06 from "../images/single-sofa-02.png";
import productImg007 from "../images/single-sofa-03.png";

import productImg07 from "../images/arm-chair-01.png";
import productImg08 from "../images/arm-chair-02.png";
import productImg09 from "../images/arm-chair-03.png";
import productImg10 from "../images/arm-chair-04.png";

import productImg13 from "../images/phone-01.png";
import productImg14 from "../images/phone-02.png";
import productImg15 from "../images/phone-03.png";
import productImg16 from "../images/phone-04.png";
import productImg17 from "../images/phone-05.png";
import productImg18 from "../images/phone-06.png";

import productImg19 from "../images/watch-01.jpg";
import productImg20 from "../images/watch-02.jpg";
import productImg21 from "../images/watch-03.jpg";
import productImg22 from "../images/watch-04.jpg";

import productImg23 from "../images/wireless-01.png";

import productImg25 from "../images/wireless-03.png";

import cosmetics from "../images/1.jpeg";
import cosmetics2 from "../images/2.jpeg";
import cosmetics3 from "../images/3.jpeg";
import cosmetics4 from "../images/4.jpeg";
import cosmetics5 from "../images/5.jpeg";
import cosmetics6 from "../images/6.jpeg";
import cosmetics7 from "../images/7.jpeg";
import cosmetics8 from "../images/9.jpeg";
import cosmetics9 from "../images/8.jpeg";
const products = [
	{
		id: "01",
		productName: "Stone and Beam Westview ",
		ar: "https://shopping.qurashi.xyz/victorian.html",
		imgUrl: productImg01,
		category: "sofa",
		price: 193,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},

	{
		id: "02",
		productName: "Rivet Bigelow Modern ",
		imgUrl: productImg02,
		category: "sofa",
		ar: "https://shopping.qurashi.xyz/victorian3.html",
		price: 253,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "03",
		productName: "Amazon Brand Modern Sofa",
		imgUrl: productImg03,
		category: "sofa",
		"ar":"https://shopping.qurashi.xyz/victorian4.html",
		price: 173,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},
	{
		id: "26",
		productName: "Rivet Bigelow Modern ",
		imgUrl: productImg4,
		category: "sofa",
		"ar":"https://shopping.qurashi.xyz/victorian2.html",
		price: 253,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},
	{
		id: "04",
		productName: "Fllufy Sheep Sofa",
		imgUrl: productImg04,
		category: "sofa",
		"ar":"https://shopping.qurashi.xyz/sofasingle3.html",
		price: 163,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "05",
		productName: "Faux Velvet Sofa",
		imgUrl: productImg05,
		category: "sofa",
		"ar":"https://shopping.qurashi.xyz/sofasingle2.html",
		price: 163,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "06",
		productName: "Fllufy Sheep Sofa",
		imgUrl: productImg06,
		category: "sofa",
		"ar":"https://shopping.qurashi.xyz/sofasingle.html",
		price: 163,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},
	{
		id: "07",
		productName: "Sakarias Armchair",
		imgUrl: productImg07,
		ar: "https://shopping.qurashi.xyz/chair.html",
		category: "chair",
		price: 99,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "27",
		productName: "Modern Arm Sofa",
		imgUrl: productImg007,
		category: "sofa",
		ar: "https://shopping.qurashi.xyz/sofasingle1.html",
		price: 173,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "08",
		productName: "Baltsar Chair",
		imgUrl: productImg08,
		category: "chair",
		"ar":"https://shopping.qurashi.xyz/chair1.html",
		price: 89,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "09",
		productName: "Helmar Chair",
		imgUrl: productImg09,
		category: "chair",
		ar: "https://shopping.qurashi.xyz/chair2.html",
		price: 112,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},

	{
		id: "10",
		productName: "Apple iPhone",
		imgUrl: productImg13,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone.html",
		price: 799,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},
	{
		id: "25",
		productName: "Sakarias Armchair",
		imgUrl: productImg10,
		category: "chair",
		"ar":"https://shopping.qurashi.xyz/chair3.html",
		price: 99,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.6,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.7,
	},
	{
		id: "11",
		productName: "Redmi 9",
		imgUrl: productImg14,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone1.html",
		price: 799,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "12",
		productName: "Galaxy S8",
		imgUrl: productImg15,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone2.html",
		price: 599,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "13",
		productName: "DANGER",
		imgUrl: productImg16,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone3.html",
		price: 799,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "14",
		productName: "Apple iPhone 13 Pro",
		imgUrl: productImg17,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone4.html",
		price: 899,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "15",
		productName: "HUAWEI",
		imgUrl: productImg18,
		category: "mobile",
		"ar":"https://shopping.qurashi.xyz/phone4.html",
		price: 699,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "16",
		productName: "Rolex Watch",
		imgUrl: productImg19,
		category: "watch",
		ar: "https://shopping.qurashi.xyz/steampunk.html",
		price: 299,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "17",
		productName: "Timex Easy Reader Watch",
		imgUrl: productImg20,
		category: "watch",
		ar: "https://shopping.qurashi.xyz/handWatch.html",
		price: 299,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "18",
		productName: "Rolex Watch",
		imgUrl: productImg21,
		category: "watch",
		ar: "https://shopping.qurashi.xyz/digitalWatch.html",
		price: 299,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "19",
		productName: "Apple Watch",
		imgUrl: productImg22,
		category: "watch",
		price: 399,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "20",
		productName: "Beat Studio Wireless",
		imgUrl: productImg23,
		category: "wireless",
		ar: "https://shopping.qurashi.xyz/handphone.html",
		price: 199,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},

	{
		id: "22",
		productName: "Beat EP Headphones",
		imgUrl: productImg25,
		category: "wireless",
		ar: "https://shopping.qurashi.xyz/handphone1.html",
		price: 199,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 4.8,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
			{
				rating: 4.9,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.8,
	},
	{
		id: "23",
		productName: "Cosmetics",
		imgUrl: cosmetics,
		ar: "https://shopping.qurashi.xyz/makeup.html",
		category: "Cosmetics",
		price: 44,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "24",
		productName: "Cosmetics",
		imgUrl: cosmetics2,
		category: "Cosmetics",
		price: 50,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "25",
		productName: "Cosmetics",
		imgUrl: cosmetics3,
		ar: "https://shopping.qurashi.xyz/cc.html",
		category: "Cosmetics",
		price: 49,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "26",
		productName: "Cosmetics",
		imgUrl: cosmetics4,
		category: "Cosmetics",
		price: 19,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "26",
		productName: "Cosmetics",
		imgUrl: cosmetics5,
		category: "Cosmetics",
		price: 89,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "27",
		productName: "Cosmetics",
		imgUrl: cosmetics6,
		category: "Cosmetics",
		price: 20,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "28",
		productName: "Cosmetics",
		imgUrl: cosmetics7,
		category: "Cosmetics",
		price: 100,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "29",
		productName: "Cosmetics",
		imgUrl: cosmetics8,
		category: "Cosmetics",
		price: 113,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
	{
		id: "30",
		productName: "Cosmetics",
		imgUrl: cosmetics9,
		category: "Cosmetics",
		price: 99,
		shortDesc:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
		reviews: [
			{
				rating: 3.7,
				text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
			},
		],
		avgRating: 4.5,
	},
];

export default products;
